var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { "data-test": _vm.CypressTarget("HelpPage"), padding: "" } },
    [
      _c("h4", [_vm._v(_vm._s(_vm.$t(_vm.$route.meta.pageName)))]),
      _c(
        "q-list",
        { attrs: { "data-test": _vm.CypressTarget("FAQList") } },
        _vm._l(_vm.helpItems, function(help, index) {
          return _c("item-help-collapsible-faq", {
            key: index,
            attrs: { title: help.title, content: help.content }
          })
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }